// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2MMSw","question":"Question_question__2IGmk","description":"Question_description__1lWVz"};